import * as Immutable from 'immutable';
import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import { closeEventsCards, getEvents, getEventsOptions, toogleEventsCards } from '../../actions/Events/DataActions';
import { Container } from '../../components';
import EventsHeader from '../../components/Events/EventsHeader';
import EventsMain from '../../components/Events/EventsMain';
import { List } from '../../components/Events/List';
import { Navigation } from '../../components/Events/Navigation';
import { StateType } from '../../reducers';
import { DispatchConnect } from '../../types';
import { ErrorBoundary } from '../ErrorBoundary';

interface EventsStateDispatchers {
  dispatchGetEvents: () => void;
  dispatchGetEventsOptions: () => void;
  dispatchToogleEventsCards: (event: string) => void;
  dispatchCloseEventsCards: () => void;
}

interface EventsStateProps {
  isFetching: boolean;
  isFetchingOptions: boolean;
  eventsOpen: Immutable.List<string>;
}

interface EventRouteProps {
  id: string;
}

type EventsGenericType = EventsStateDispatchers & EventsStateProps & RouteComponentProps<EventRouteProps>;

class Events extends React.Component<EventsGenericType, {}> {
  componentDidMount() {
    this.props.dispatchGetEvents();
    this.props.dispatchGetEventsOptions();
  }

  UNSAFE_componentWillMount() {
    this.props.dispatchCloseEventsCards();
  }

  render() {
    return (
      <ErrorBoundary showUI={true} isNotFullScreen={true}>
        <section className="events ws-events">
          <Container>
            {/*
            // @ts-ignore todo: remove ts-ignore when ts is updated */}
            <EventsMain
              pathId={this.props.match.params.id}
              handleToogleEventsCards={this.props.dispatchToogleEventsCards}
              handleCloseEventsCards={this.props.dispatchCloseEventsCards}
            >
              <EventsHeader />
              <Navigation />
              <List />
            </EventsMain>
          </Container>
        </section>
      </ErrorBoundary>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): EventsStateDispatchers => ({
  dispatchGetEvents: () => dispatch(getEvents()),
  dispatchGetEventsOptions: () => dispatch(getEventsOptions()),
  dispatchToogleEventsCards: (event: string) => dispatch(toogleEventsCards(event)),
  dispatchCloseEventsCards: () => dispatch(closeEventsCards()),
});

export default withRouter(connect<{}, DispatchConnect<EventsStateDispatchers>, any, StateType>(null, mapDispatchToProps)(Events));
